import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';
//import comm from '@utils/comm';

export function SET_LOCATION(store, location) {
  PARAM_CHANGE(store, BLOCKS.HISTORY_PANELS.CURRENT_LOCATION, location);
}
export function SET_SUBLOCATION(store, location) {
  PARAM_CHANGE(store, BLOCKS.HISTORY_PANELS.CURRENT_SUBLOCATION, location);
}

export function OPEN_POPUP(store, type) {
  PARAM_CHANGE(store, BLOCKS.APP.POPUP, type);
}
/*
export function BEGIN_RECON(store) {
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.WITH_TREES, true);
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.WITH_LEGENDS, false);
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.ZOOM, 1);
}*/
/*
function RESET_MAP_PICKABLE_PARAMS(store) {
  PARAM_CHANGE(store, BLOCKS.MAP.CROSSHAIR_SETTING, -1);
  PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, [{x: -1, y: -1}, {x: -1, y: -1}]);
  PARAM_CHANGE(store, BLOCKS.MAP.PICKING_MARKER, {x: -1, y: -1});
}

*/
